import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

export const productGallery = () => {
  let swiper = null;
  let swiperThumbnails = null;
  const buybox = document.querySelector('.js-buybox');
  if (!buybox) return;
  const prevButton = buybox.querySelector('.thumbs-slider-button-left');
  const nextButton = buybox.querySelector('.thumbs-slider-button-right');

  const init = () => {
    initializeThumbnails();
    initializeGallery();
    disableButton();
  };

  const initializeThumbnails = () => {
    const thumbnailElement = buybox.querySelector(
      '.js-gallery-thumbnails-swiper',
    );
    if (!thumbnailElement) return;

    swiperThumbnails = new Swiper(thumbnailElement, {
      slidesPerView: 5,
      slidesOffsetAfter: 16,
      slideToClickedSlide: true,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      observer: true,
      observeParents: true,
      mousewheel: {
        forceToAxis: true,
      },
      freeMode: true,
      breakpoints: {
        375: {
          slidesPerView: 6.5,
          direction: 'horizontal',
          spaceBetween: 8,
        },
        768: {
          slidesPerView: 'auto',
          direction: 'vertical',
          slidesOffsetAfter: 4,
        },
      },
    });

    swiperThumbnails.slides.forEach((slide, index) => {
      slide.addEventListener('click', () => {
        swiper.slideTo(index);
        syncThumbnails();
      });
    });
  };

  const initializeGallery = () => {
    const galleryElement = buybox.querySelector('.js-gallery-swiper');
    if (!galleryElement) return;

    swiper = new Swiper(galleryElement, {
      slidesPerView: 1,
      mousewheel: {
        forceToAxis: true,
      },
      breakpoints: {
        375: {
          spaceBetween: 8,
          slidesPerView: 1.059,
          slidesOffsetAfter: 8,
        },
        1024: {
          slidesPerView: 1.059,
          spaceBetween: 8,
          slidesOffsetAfter: 8,
        },
        1280: {
          slidesPerView: 1,
        },
      },
      thumbs: {
        swiper: swiperThumbnails,
      },
      navigation: {
        nextEl: '.slider-button-right',
        prevEl: '.slider-button-left',
        disabledClass: 'pointer-events-none opacity-0',
      },
      pagination: {
        el: '.pdp-gallery-pagination',
        clickable: true,
        renderBullet: function (index, className) {
          return `<span class="${className} w-2.5 h-2.5 rounded-full bg-gray-200 transition-all duration-300 ease-in-out"></span>`;
        },
      },
      on: {
        slideChange: () => {
          syncThumbnails();
          disableButton();
          updatePaginationStyle();
        },
        init: () => {
          updatePaginationStyle();
        },
      },
    });
  };

  const updatePaginationStyle = () => {
    const bullets = document.querySelectorAll(
      '.pdp-gallery-pagination .swiper-pagination-bullet',
    );
    bullets.forEach((bullet) => {
      if (bullet.classList.contains('swiper-pagination-bullet-active')) {
        bullet.classList.add('w-5', 'h-2.5', 'rounded-md', 'bg-gray-900');
        bullet.classList.remove(
          'w-2.5',
          'h-2.5',
          'rounded-full',
          'bg-gray-200',
        );
      } else {
        bullet.classList.add('w-2.5', 'h-2.5', 'rounded-full', 'bg-gray-200');
        bullet.classList.remove('w-5', 'h-2.5', 'rounded-md', 'bg-gray-900');
      }
    });
  };

  const syncThumbnails = () => {
    const activeIndex = swiper.activeIndex;

    if (swiperThumbnails) {
      swiperThumbnails.slides.forEach((slide, index) => {
        slide.classList.toggle(
          'swiper-slide-thumb-active',
          index === activeIndex,
        );
      });
      const activeSlide = swiperThumbnails.slides[activeIndex];
      if (activeSlide) {
        activeSlide.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'nearest',
        });
      }
    }
  };

  nextButton?.addEventListener('click', () => {
    swiper.slideNext();
    disableButton();
  });

  prevButton?.addEventListener('click', () => {
    swiper.slidePrev();
    disableButton();
  });

  const disableButton = () => {
    const disabledClasses = ['pointer-events-none', 'opacity-0'];
    const totalSlides = swiper.slides.length;

    const isLastSlide = swiper.activeIndex === totalSlides - 1;
    const isPrevDisabled =
      swiper.activeIndex === 0 && swiper.slides.length >= 6;

    // Disable or enable buttons dynamically
    disabledClasses.forEach((className) => {
      nextButton?.classList.toggle(className, isLastSlide); // Disable 'next' on last slide
      prevButton?.classList.toggle(className, isPrevDisabled); // Disable 'prev' on first or >= 6
    });
  };

  return {
    init,
  };
};
